module.exports = __webpack_public_path__ + "static/media/sensable_88.87581d16.jpg";